'use strict';
$(".video-still").on("click", function () {
    var $iframe = $(this).closest('.video-section').find('.video .video-responsive iframe');
    var $videoStill = $(this);

    if ($iframe.length > 0) {
        var $player = new Vimeo.Player($iframe);
        $player.on('ended', function () {
            videoEnded($videoStill);
        });
    }

    var $directVideo = $(this).closest('.video-section').find('.video .video-responsive video');
    if ($directVideo.length > 0) {
        var $player = $directVideo.get(0);
        var $videoStill = $(this);

        $($directVideo).on('ended',function(){
            videoEnded($videoStill);
          });
    }

    $(this).css('display', 'none');
    $player.play();
});


function videoEnded(videoStill) {
    setTimeout(function () {
        videoStill.css('display', 'block');
    }, 500);
};